export default "* Høresans\n* Naturlige lyde\n* Menneskeskabte lyde\n* Behagelige lyde\n* Ubehagelige lyde\n";